(() => {
  const copy = [
    ['How It Works', 'How it works'],
    ['Shipping Policies', 'Shipping policies'],
    ['Customer Reviews', 'Customer reviews'],
    ['Visit Support', 'Visit support'],
    ['Strikeman Support', 'Strikeman support'],
    ['Frequently Asked Questions', 'Frequently asked questions'],
    ['How to Videos', 'How to videos'],
    ['How-to Videos', 'How-to videos'],
    ['Strikeman Blog', 'Strikeman blog'],
    ['Strikeman Manuals', 'Strikeman manuals'],
    ['Dry-Fire Systems', 'Dry-fire systems'],
    ['Laser Cartridges', 'Laser cartridges'],
    ['Overall Dry Fire Systems', 'Overall dry fire systems'],
    ['Dry Fire Systems and cartridge', 'Dry fire systems and cartridge'],
    ['Guarantee and Warranty', 'Guarantee and warranty'],
    ['45-Day Money-back Guarantee', '45-day money-back guarantee'],
    ['45-Day Money-Back Guarantee', '45-day money-back guarantee'],
    ['Warranty Policy', 'Warranty policy'],
    ['Refund Policy', 'Refund policy'],
    ['45-Day Money-back Guarantee Return Policy', '45-day money-back guarantee return policy'],
    ['Return Requirements', 'Return requirements'],
    ['Purchases from Third Party sellers', 'Purchases from third party sellers'],
    ['Final Sale', 'Final sale'],
    ['Training Tips & Guides', 'Training tips & guides'],
    ['BUILD YOUR OWN BUNDLE', 'Build your own bundle'],
    ['Shop Accessories', 'Shop accessories'],
    ['The Strikeman App', 'The Strikeman app'],
    ['THE STAR OF THE SHOW', 'The star of the show'],
    ['TRACK EVERY SHOT', 'Track every shot'],
    ['SHOP ALL', 'Shop all'],
    ['Best-Selling Bundles', 'Best-selling bundles'],
    ['LASER CARTRIDGES', 'Laser cartridges'],
    ['SIRT TRAINING PISTOL', 'SIRT training pistol'],
    ['THE SMARTSHOT', 'The SmartShot'],
    ['TARGETS & ACCESSORIES', 'Targets & accessories'],
    ['PRO MEMBERSHIP & GIFT CARDS', 'Pro Membership & gift cards'],
    ['SHOP DRY-FIRE SYSTEMS', 'Shop dry-fire systems'],
    ['MEET THE STRIKEMAN SMARTSHOT', 'Meet the Strikeman SmartShot'],
    ['One of a Kind', 'One of a kind'],
    ['More Compatible Than Ever', 'More compatible than ever'],
    ['Smartshot FAQ', 'SmartShot FAQ'],
    ['AVAILABLE NOW', 'Available now'],
    ['Need a Strikeman Target, too?', 'Need a Strikeman target, too?'],
    ['Strikeman Free app', 'Strikeman free app'],
    ['Changing or Cancelling Your Shipment', 'Changing or cancelling your shipment'],
    ['Shipping and Delivery', 'Shipping and delivery'],
    ['Risk of Loss', 'Risk of loss'],
    ['Shipping Insurance', 'Shipping insurance'],
    ['High-Value Shipments', 'High-value shipments'],
    ['Carrier Inquiries', 'Carrier inquiries'],
    ['TERMS OF USE', 'Terms of use'],
    ['Accessing the Site and Account Registration and Security', 'Accessing the Site and account registration and security'],
    ['Intellectual Property Rights', 'Intellectual property rights'],
    ['Prohibited Uses', 'Prohibited uses'],
    ['User Contributions; Feedback', 'User contributions; feedback'],
    ['Monitoring and Enforcement', 'Monitoring and enforcement'],
    ['Content Standards', 'Content standards'],
    ['Product Descriptions', 'Product descriptions'],
    ['Order Acknowledgment', 'Order acknowledgment'],
    ['PRODUCTS DISCLAIMERS', 'Products disclaimers'],
    ['Waiver of Class Action; Arbitration Agreement', 'Waiver of class action; arbitration agreement'],
    ['Entire Agreement', 'Entire agreement'],
    ['Contact Us', 'Contact us'],
    ['PRIVACY POLICY', 'Privacy policy'],
    ['2. The Types and Categories of Personal Information We Collect', '2. The types and categories of personal information we collect'],
    ['3. Collection of Technical/Online Data', '3. Collection of technical/online data'],
    ['4. Sources of Information', '4. Sources of information'],
    ['5. How We Use Your Information / Purpose of Collection', '5. How we use your information / purpose of collection'],
    ['6. Sharing Information / Third-Party Disclosures', '6. Sharing information / third-party disclosures'],
    ['7. Social Media/ Platform Data Rights', '7. Social media/ platform data rights'],
    ['8. Links to Other Websites; Your Direct Third-Party Disclosures', '8. Links to other websites; your direct third-party disclosures'],
    ['9. Data Retention and Localization', '9. Data retention and localization'],
    ['11. No Data Collected from Children', '11. No data collected from children'],
    ['12. Publicly Posted Information; Product Reviews', '12. Publicly posted information; product reviews'],
    ['13. Your Responsibilities', '13. Your responsibilities'],
    ['14. Updating Your Information', '14. Updating your information'],
    ['15. Australia Privacy Rights', '15. Australia privacy rights'],
    ['16. Brazil Privacy Rights', '16. Brazil privacy rights'],
    ['17. Canada Privacy Rights', '17. Canada privacy rights'],
    ['18. European/UK Privacy Rights', '18. European/UK privacy rights'],
    ['19. Mexico Privacy Rights', '19. Mexico privacy rights'],
    ['20. U.S. State Privacy Rights', '20. U.S. state privacy rights'],
    ['21. Opt-Out/Targeted Advertising', '21. Opt-out/targeted advertising'],
    ['22. Legal Basis for Processing (For EEA/UK/Switzerland/Brazil/Mexico Only)', '22. Legal basis for processing (for EEA/UK/Switzerland/Brazil/Mexico only)'],
    ['23. Marketing Preferences', '23. Marketing preferences'],
    ['24. Global Privacy Control; Do-Not-Track Signals', '24. Global Privacy Control; Do-Not-Track signals'],
    ['25. Persons with Disabilities', '25. Persons with disabilities'],
    ['26. Events and Video Teleconferencing', '26. Events and video teleconferencing'],
    ['27. Changes to the Policy', '27. Changes to the policy'],
    ['28. Contact Us', '28. Contact us'],
    ['About Strikeman', 'About Strikeman'],
    ['The Strikeman Story', 'The Strikeman story'],
    ['Meet the Team', 'Meet the team'],
    ['Our Story', 'Our story'],
    ['Live-Fire Beta Guide', 'Live-Fire beta guide'],
    ['Strikeman Target Print Guide', 'Strikeman target print guide'],
    ['Train safely at homewith Laser dry-fire', 'Train safely at homewith laser dry-fire'],
    ['Train safely at home with Laser dry-fire', 'Train safely at home with laser dry-fire'],
    ['Shop by Category', 'Shop by category'],
    ['Complete Systems', 'Complete systems'],
    ['Add a Caliber', 'Add a caliber'],
    ['Upgrades & Add-Ons', 'Upgrades & add-ons'],
    ['Training Pistol', 'Training pistol'],
    ['Holiday Deals by Category', 'Holiday deals by category'],
    ['Shop the Sale', 'Shop the sale'],
    ['Activate Your Membership', 'Activate your membership'],
    ['End User License Agreement', 'End user license agreement'],
    ['The Laser Cartridge', 'The laser cartridge'],
    ['The Target', 'The target'],
    ["What's Included?", "What's included?"],
    ["What's Included:", "What's included:"],
    ['Setting Up Your First Session', 'Setting up your first session'],
    ['The App', 'The app'],
    ['The Accessories', 'The accessories'],
    ['The Essentials', 'The essentials'],
    ['The Upgrade', 'The upgrade'],
    ['Compare dry-fire systems', 'Compare dry-fire systems'],
    ['You might also like', 'You might also like'],
    ['Frequently asked questions', 'Frequently asked questions'],
    ['Reviews', 'Reviews']
  ];
  const normalize = (text) => text.replace(/\s+/g, ' ').trim();
  const replacements = new Map(copy.flatMap(([before, after]) => [[before, after], [after, after]]));
  const headings = 'h1,h2,h3,h4,h5,h6';
  const excluded = '.header,.site-header,[role="banner"],.menu-drawer,button,[role="button"],[contenteditable="true"],product-card,.product-grid__item,[data-related-card],.spp h1,.sep h1,.sblog-article-card,.jdgm-rev,.jdgm-carousel-item,.spp-review-card,.sf-review-card,[data-heading-case="preserve"]';

  function updateHeading(heading) {
    if (heading.closest(excluded) || heading.querySelector('a[href*="/products/"],a[href*="/blogs/"]')) return;
    if (heading.closest('nav,[role="navigation"]') && !heading.closest('main,#MainContent,[role="main"]')) return;
    const original = normalize(heading.textContent);
    const replacement = replacements.get(original);
    heading.setAttribute('data-strikeman-sentence-case', '');
    if (!replacement || original === replacement) return;
    // Replace letter casing only, retaining inline markup, whitespace and links.
    if (original.toLowerCase() !== replacement.toLowerCase()) return;
    const letters = Array.from(replacement.replace(/\s/g, ''));
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    let offset = 0;
    let node;
    while ((node = walker.nextNode())) {
      const value = Array.from(node.data, (character) => /\s/.test(character) ? character : letters[offset++]).join('');
      if (node.data !== value) node.data = value;
    }
  }

  document.querySelectorAll(headings).forEach(updateHeading);
  const pending = new Set();
  let queued = false;
  const enqueue = (node) => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const heading = element.closest(headings);
    if (heading) pending.add(heading);
    element.querySelectorAll(headings).forEach((item) => pending.add(item));
  };
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') enqueue(record.target);
      else record.addedNodes.forEach(enqueue);
    }
    if (!pending.size || queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      pending.forEach((heading) => { if (heading.isConnected) updateHeading(heading); });
      pending.clear();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
